// Import and use the Colors const directly in javascript files.
// This object is in colors_to_sass.js to generate the color sass variables
// to be use style sheets

// after editing this file, run  `yarn run colors-to-sass` to generate the updated sass variables
// for questions ask @josh@workpatterns.com

const Colors = {
  purple: {
    25: '#F2EDF9',
    50: '#E8DEF4',
    100: '#DCCCEE',
    200: '#CBB3E5',
    300: '#B999DC',
    400: '#A780D3',
    500: '#9666CB',
    600: '#854DC2',
    700: '#7333B9',
    800: '#5000A8',
    900: '#380076',
  },
  gray: {
    50: '#F2F1F3',
    75: '#E5E3E8',
    100: '#D3D0D8',
    200: '#BDB8C5',
    300: '#A7A1B2',
    400: '#91899E',
    500: '#7C718B',
    600: '#615574',
    700: '#504265',
    800: '#3A2B51',
    900: '#24133E',
  },
  blue: {
    50: '#DBF0F7',
    100: '#BDE3F1',
    200: '#8FCFE7',
    300: '#61BBDD',
    400: '#33A8D3',
    500: '#0092C8',
    600: '#007AA7',
    700: '#00668C',
    800: '#004964',
    900: '#003143',
  },
  orange: {
    50: '#FDE8DC',
    100: '#FBD2BD',
    200: '#FAC4A8',
    300: '#F8B18B',
    400: '#F79D6E',
    500: '#F58A51',
    600: '#DB6E34',
    700: '#BE541B',
    800: '#8F3E14',
    900: '#672805',
  },
  green: {
    50: '#D9F7EC',
    100: '#AAEED6',
    200: '#80E5C1',
    300: '#55DDAC',
    400: '#2AD498',
    500: '#00CC83',
    600: '#00AA6D',
    700: '#008857',
    800: '#006641',
    900: '#00442C',
  },
  yellow: {
    50: '#FFEFC5',
    100: '#FFE9B2',
    200: '#FFDE8B',
    300: '#FFD465',
    400: '#FFC93E',
    500: '#FFBE18',
    600: '#D49E14',
    700: '#AA7F10',
    800: '#805F0C',
    900: '#553F08',
  },
  red: {
    50: '#FEE7EC',
    100: '#FEDAE1',
    200: '#FDC1CD',
    300: '#FBA2B3',
    400: '#FA839A',
    500: '#F84568',
    600: '#DA0C35',
    700: '#B60A2C',
    800: '#910823',
    900: '#6D061A',
  },
  white: {
    0: '#ffffff',
  },
  black: {
    0: '#000000',
  },
};

module.exports = Colors;
